
import * as localizations from './localizations';
export const appStrings = localizations;

export * from './components/LocalizedRouter';
export * from './components/LocalizedSwitch';
export * from './components/LanguageSwitcher';
